import React, { useState } from 'react';
import './App.css';

function App() {
  const [mealDescription, setMealDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!mealDescription.trim()) return;
    
    setLoading(true);
    
    try {
      // This would be an API call to the Lambda function
      // For now, we'll simulate a response
      setTimeout(() => {
        setResponse(`Thanks for sharing your meal: ${mealDescription}. 
        
Based on your description, I've identified the following items:
- Chicken breast (6 oz)
- Brown rice (1 cup)
- Broccoli (1 cup)

Total nutritional information:
- Calories: 458
- Carbs: 56g
- Protein: 44g
- Fat: 6g`);
        
        setMealDescription('');
        setLoading(false);
      }, 1500);
    } catch (error) {
      console.error('Error processing meal:', error);
      setLoading(false);
    }
  };

  return (
    <div className="App" style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1>Trackable Diet - Meal Logger</h1>
      
      <div style={{ 
        padding: '20px', 
        border: '1px solid #ccc', 
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <p>Please describe your meal in detail. Include foods, approximate portions, and any preparation methods.</p>
        
        <form onSubmit={handleSubmit}>
          <textarea
            style={{ 
              width: '100%', 
              padding: '10px',
              marginBottom: '10px',
              minHeight: '100px'
            }}
            placeholder="Describe your meal here..."
            value={mealDescription}
            onChange={(e) => setMealDescription(e.target.value)}
            disabled={loading}
          />
          
          <button 
            type="submit"
            disabled={loading || !mealDescription.trim()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Processing...' : 'Send'}
          </button>
        </form>
      </div>
      
      {response && (
        <div style={{ 
          padding: '20px', 
          border: '1px solid #ccc', 
          borderRadius: '5px',
          backgroundColor: '#f5f5f5',
          whiteSpace: 'pre-wrap'
        }}>
          <h3>AI Response:</h3>
          <p>{response}</p>
        </div>
      )}
    </div>
  );
}

export default App;
